__turbopack_context__.v({
  "box-default": "section-visual-module-scss-module__GUCf6W__box-default" + " " + __turbopack_context__.i(789410)["pad-vertical"],
  "fade": "section-visual-module-scss-module__GUCf6W__fade",
  "visual": "section-visual-module-scss-module__GUCf6W__visual",
});
